module.exports = __webpack_public_path__ + "img/logo-darkblue.cd0201ca.jpg";